<template>
  <el-container class="login-container">
    <el-header>
      <el-button style="margin-top: 20px" icon="el-icon-arrow-left" plain @click="back">返回</el-button>
    </el-header>
    <el-main class="login-main">
      <el-image class="logo" :src="logoUrl"></el-image>
      <el-form :model="loginForm" :rules="rules" ref="loginForm" style="width: 250px; margin-top: 20px">
      <el-form-item prop="phoneNumber">
        <el-input v-model="loginForm.phoneNumber" placeholder="请输入手机号"></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input v-model="loginForm.password" placeholder="请输入密码" show-password></el-input>
      </el-form-item>
      <el-form-item>
      <el-button style="width: 250px;" type="primary" @click="doLogin" v-loading="logining">登录</el-button>
      </el-form-item>
      </el-form>
      <router-link class="login-reg" to="register"><a>没有账号？点此立即注册</a></router-link>
      <router-link class="login-reg" to="forgot"><a>忘记密码？</a></router-link>
    </el-main>
  </el-container>
</template>

<script>

export default {
  name: 'Login',
  data () {
    return {
      logoUrl: require('../assets/login-logo.png'),
      loginForm: {
        phoneNumber: '',
        password: ''
      },
      logining: false,
      rules: {
        phoneNumber: [
          { required: true, message: '请输入手机号', trigger: 'change' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'change' }
        ]
      }
    }
  },
  methods: {

    back () {
      this.$router.go(-1)
    },

    toRegister () {
      this.$router.push({path: '/register'})
    },

    doLogin () {
      var isValid = true
      this.$refs['loginForm'].validate((valid) => {
        isValid = valid
      })

      if (!isValid) {
        console.log('error submit!!')
        return false
      }

      var postData = {username: this.$data.loginForm.phoneNumber, password: this.$data.loginForm.password}
      this.$data.logining = true
      this.$axios.post('/login', this.$qs.stringify(postData)).then(res => {
        this.$data.logining = false
        if (res.data['status'] === 200) {
          this.$store.dispatch('setLogin', 'true')
          this.$message({
            message: '登录成功！',
            type: 'success'
          })
          // 登录成功回到前一页
          this.$router.go(-1)
        } else {
          this.$message.error(res.data['message'])
        }
      }).catch(e => {
        this.$data.logining = false
        if (e.response) {
          // 请求已发出，服务器返回状态码不是2xx。
          if (e.response.status === 401) {
            this.$message.error('登录失败，请检查用户名或密码！')
          } else {
            this.$message.error('登录失败!')
          }
        } else if (e.request) {
          this.$message.error('登录失败，服务器未响应！')
        } else {
          // 发送请求时异常，捕捉到错误
          this.$message.error(e.message)
        }
      })
    }
  }
}
</script>

<style>
  .login-container {
    flex-direction: column;
  }

  .login-main {
    margin: auto;
    text-align: center;
  }

  .logo {
    margin-top: 30px;
    border-radius: 10px;
    width: 100px;
    height: 100px;
    margin: 0 auto;
  }

  .login-reg {
    margin-top: 20px;
    text-align: right;
    color: #409EFF;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue